// ************************ IMPORTS **************************

// Styles
import "../styles/styles.scss";
import "../styles/style-mobile.scss";
import "../styles/style-tablette.scss";
import "./styles/styles.scss";
import "./styles/style-mobile.scss";
import "./styles/style-tablette.scss";

// Librairies
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/fr";

// Containers/Components
import OfferModal from "../../containers/Modals/OfferModal/OfferModal";
import VideoModal from "./Pages/PepiteInfos/Tutos/VideoModal";
import StripePaymentModal from "../Modals/StripePaymentModal";

// Hooks
import useWindowDimensions from "../../hook/useWindowDimension";

// Utils
import {getPartnerUrl} from "../../utils/baseUrl";
import {getUrlParam} from "../../utils/getUrlParam";
import Nav from "../../containers/Nav/Nav";
import FreeQuestionChatBot from "../Chat/ChatBotFreeQuestion/FreeQuestionChatBot/FreeQuestionChatBot";
import DashboardQuestions from "./Pages/YourQuestions/DashboardQuestions";
import Accueil from "./Pages/Accueil";
import CareManagerColumn from "./Pages/CareManagerColumn/CareManagerColumn";
import PepiteInfos from "./Pages/PepiteInfos/PepiteInfos";
import LeBlog from "../../containers/Home/Pages/LeBlog";
import LesFichesPratiques from "./Pages/PepiteInfos/LesFichesPratiques/LesFichesPratiques";
import Index from "./Pages/PepiteInfos/Tutos/Tutos";
import Account from "./Pages/Account/Account";
import loading from "../../assets/gif/loading.gif";

dayjs.locale("fr");


// ************************ COMPONENT **************************

const Home = ({
                  checkIsLogged,
                  getCases,
                  clearListMessages,
                  clearListDocuments,
                  getPraticalSheets,
                  showAccountModal,
                  dataUser,
                  selectedVideo,
                  showVideoModal,
                  listCases,
                  redirection,
                  getQuestionsAnswers,
                  questionsAndAnswers,
                  getSouscription,
                  showOfferModal,
                  setShowOfferModal,
                  setShowSheetsAccueil,
                  setShowVideoModal,
                  navItem,
                  handleOpenNavItem,
                  logout,
                  setShowAccountModal,
                  getBlogPosts,
                  postsList
              }) => {
    const history = useHistory();
    const {idExt, isSouscription} = dataUser; // Utilisé pour determiner s'il existe une souscriptions
    const {width} = useWindowDimensions();

    const [openFreeQuestionChatBot, setOpenFreeQuestionChatBot] = useState(false);
    const [showElement, setShowElement] = React.useState(true);
    const [pagePerso, setPagePerso] = useState(false);

// Redirection automatique sur le bon onglet (mobile) selon les cas
    const [casesRedirection, setCasesRedirection] = useState(false);
// Affichage des questions
    const [displayQuestions, setDisplayQuestions] = useState(false);
// Détermine la classeName de l'onglet en cours (accueil, careManager, ressources, votreCompte)
    const [classname, setClassname] = useState("");
// Ouvre le modal iframe page partenaire
    const [iframe, setIframe] = useState(false);

    useEffect(() => {
            setTimeout(function () {
                setShowElement(false);
            }, 5000);
        },
        []);
// ************************ STRIPE **************************
    useEffect(() => {
// Permet d'ouvrir le modal d'offre lorsqu'il y a le paramètre get ? offer=true
        const urlParams = new URLSearchParams(window.location.search);
        const offer = urlParams.get("offer");
        if (offer == "true") {
            setShowOfferModal(true);
            console.log("openoffermodal");
        }
    }, []);

    useEffect(() => {
        async function checkLoginFirst() {
            let id = getUrlParam("id");
            let idUser = getUrlParam("idUser");
            let email = getUrlParam("email");
            if (id !== null && idUser !== null && email !== null) {
                window.localStorage.setItem("id", id);
                window.localStorage.setItem("idUser", idUser);
                window.localStorage.setItem("email", email);
            }
            await checkIsLogged();
        }

// On s'assure que checkIsLogged est appelé avant les autres requêtes API
// Ce code n'est pas très élégant, à optimiser
        checkLoginFirst().then(() => {
            getCases();
            getQuestionsAnswers();
            clearListMessages();
            clearListDocuments();
            getPraticalSheets();
            getSouscription();
            getBlogPosts();
        });
    }, [showAccountModal]); // Pas sûr que ce soit bien utile d'appeler ce useEffect à chaque ouverture du modal dédié aux informations du compte
    useEffect(() => {
        if (listCases.length == 0) {
            setCasesRedirection(false);
            setClassname("accueil");
            setShowSheetsAccueil(true);
        } else {
            setCasesRedirection(true);
            setClassname("careManager");
            setShowSheetsAccueil(false);
        }
    }, [listCases]);
    const redirectToOnboarding = () => {
// Envoie un message pour communiquer avec l'application Native utilisant la webview
// et ainsi rediriger vers le composant Onboarding natif plutôt que la webview
        if (window["ReactNativeWebView"]) {
            window.ReactNativeWebView.postMessage("redirectToOnBoarding");
        } else {
            history.push("/onboarding");
        }
    };
// Redirige sur le bon onglet en version mobile selon les cas

    if (redirection === null) {
        return <div>{" "}</div>;
    }
    if (redirection === false) {
        return (
            <>
                <>
                    <div style={{position: "relative", zIndex: "10"}} id={"nav"}>
                        <Nav
                            setIframe={setIframe}
                            redirectToOnboarding={redirectToOnboarding}
                            classname={classname}
                            handleOpenNavItem={handleOpenNavItem}
                            setShowOfferModal={setShowOfferModal}
                            setDisplayQuestions={setDisplayQuestions}
                            setOpenFreeQuestionChatBot={setOpenFreeQuestionChatBot}
                            openFreeQuestionChatBot={openFreeQuestionChatBot}
                            displayQuestions={displayQuestions}
                            showOfferModal={showOfferModal}
                            pagePerso={pagePerso}
                        />
                    </div>
                    <div style={{position: "relative", zIndex: "0", paddingTop: "7.9vh"}} id={"main"}>
                        {openFreeQuestionChatBot
                            ? <FreeQuestionChatBot openFreeQuestionChatBot={openFreeQuestionChatBot}/>
                            : (!showOfferModal || (width > 599)
                                    ? {
                                        "accueil":
                                            (displayQuestions && (width > 599))
                                                ? <DashboardQuestions
                                                    questionsAndAnswers={questionsAndAnswers}
                                                    setShowOfferModal={setShowOfferModal}
                                                    setDisplayQuestions={setDisplayQuestions}
                                                    isSouscription={isSouscription}
                                                    idExt={idExt}
                                                    setOpenFreeQuestionChatBot={setOpenFreeQuestionChatBot}
                                                    openFreeQuestionChatBot={openFreeQuestionChatBot}
                                                    dataUser={dataUser}
                                                />
                                                : <Accueil
                                                    listCases={listCases}
                                                    navItem={navItem}
                                                    handleOpenNavItem={handleOpenNavItem}
                                                    dataUser={dataUser}
                                                    idExt={idExt}
                                                    isSouscription={isSouscription}
                                                    setShowOfferModal={setShowOfferModal}
                                                    pagePerso={pagePerso}
                                                    setPagePerso={setPagePerso}
                                                    setIframe={setIframe}
                                                />,
                                        "careManager":
                                            (displayQuestions && (width < 599))
                                                ? <DashboardQuestions
                                                    questionsAndAnswers={questionsAndAnswers}
                                                    setShowOfferModal={setShowOfferModal}
                                                    setDisplayQuestions={setDisplayQuestions}
                                                    isSouscription={isSouscription}
                                                    idExt={idExt}
                                                    setOpenFreeQuestionChatBot={setOpenFreeQuestionChatBot}
                                                    openFreeQuestionChatBot={openFreeQuestionChatBot}
                                                />
                                                : <CareManagerColumn
                                                    casesRedirection={casesRedirection}
                                                    redirectToOnboarding={redirectToOnboarding}
                                                    idExt={idExt}
                                                    setDisplayQuestions={setDisplayQuestions}
                                                />
                                        ,
                                        "pepiteInfos": <PepiteInfos
                                            navItem={navItem}
                                            handleOpenNavItem={handleOpenNavItem}
                                        />,
                                        "pepiteInfos-blog": <LeBlog
                                            navItem={navItem}
                                            handleOpenNavItem={handleOpenNavItem}
                                            dataUser={dataUser}
                                        />,
                                        "pepiteInfos-fichesPratiques": <LesFichesPratiques
                                            navItem={navItem}
                                            handleOpenNavItem={handleOpenNavItem}
                                            dataUser={dataUser}
                                        />,
                                        "pepiteInfos-tutos": <Index
                                            navItem={navItem}
                                            handleOpenNavItem={handleOpenNavItem}
                                            dataUser={dataUser}
                                        />,
                                        "monCompte": <Account
                                            setShowAccountModal={setShowAccountModal}
                                            showAccountModal={showAccountModal}
                                            logout={logout}
                                            dataUser={dataUser}
                                            navItem={navItem}
                                        />
                                    }[navItem]
                                    :
                                    <OfferModal setOpenFreeQuestionChatBot={setOpenFreeQuestionChatBot} idExt={idExt}/>
                            )
                        }
                    </div>
                    {width > 599 &&
                        <div id={"column"}>
                            {(showElement && width > 599)
                                ?
                                <div id={"loadingSpinner"}>
                                    <img src={loading} id={"loadingSpinner-img"} alt={"chargement en cours"}/>
                                </div>
                                :
                                <CareManagerColumn
                                    casesRedirection={casesRedirection}
                                    redirectToOnboarding={redirectToOnboarding}
                                    idExt={idExt}
                                    setDisplayQuestions={setDisplayQuestions}
                                    handleOpenNavItem={handleOpenNavItem}
                                />
                            }
                        </div>
                    }
                </>
                {showVideoModal &&
                    <VideoModal
                        selectedVideo={selectedVideo}
                        showVideoModal={showVideoModal}
                        setShowVideoModal={setShowVideoModal}
                    />
                }
                {/*Offres B2C*/}
                {(width > 599 && showOfferModal) && <OfferModal idExt={idExt}/>}
                <StripePaymentModal/>
                {iframe &&
                    <div className={"iframe"}>
                        <div className={"iframe-container"}>
                            <iframe
                                src={`${getPartnerUrl()}/${dataUser.idSociete}.html`}>
                            </iframe>
                        </div>
                        <div className={"close"} onClick={() => (setIframe(false))}>
                            <img
                                src="https://www.prevandcare.com/modules/aidant/messagerie/build/static/media/close.2c1ebd35.svg"
                                alt="fermé"/>
                        </div>
                    </div>
                }
            </>
        );
    }
};

Home.propTypes = {
    getCases: PropTypes.func,
    clearListMessages: PropTypes.func,
    clearListDocuments: PropTypes.func,
    getPraticalSheets: PropTypes.func,
    showAccountModal: PropTypes.bool,
    dataUser: PropTypes.object,
    listCases: PropTypes.array,
    checkIsLogged: PropTypes.func,
    setShowOfferModal: PropTypes.func,
    showOfferModal: PropTypes.bool,
    selectedVideo: PropTypes.string,
    showVideoModal: PropTypes.bool,
    getQuestionsAnswers: PropTypes.func,
    getSouscription: PropTypes.func,
    redirection: PropTypes.bool,
    questionsAndAnswers: PropTypes.object,
    setShowSheetsAccueil: PropTypes.func,
    setShowVideoModal: PropTypes.func,
    navItem: PropTypes.string,
    handleOpenNavItem: PropTypes.func,
    logout: PropTypes.func,
    setShowAccountModal: PropTypes.func,
    getBlogPosts: PropTypes.func,
    postsList: PropTypes.func
};

export default Home;
